module.exports = __webpack_public_path__ + "img/logo2.303110d1.png";